import Base from "./base.service.js";

export default class ReferenceService extends Base {
    constructor() {
        super("reference-number");
    }

}